import { render, staticRenderFns } from "./FixedPlugin.vue?vue&type=template&id=47bb4df1"
import script from "./FixedPlugin.vue?vue&type=script&lang=js"
export * from "./FixedPlugin.vue?vue&type=script&lang=js"
import style0 from "./FixedPlugin.vue?vue&type=style&index=0&id=47bb4df1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports